import {useEffect, useState} from "react";
import GeneralStatsItem from "../../../components/game-stats/item";
import associateServices from "../../../services";
import {useTranslation} from "react-i18next";
import {Link, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import SvgIcon from "../../../components/svg-icon";
import moment from "moment";
import Big from "big.js";
import InstrumentIcon from "../../../components/instrument-icon";
import NoData from "../../../components/no-data";
import {Tooltip} from "react-tooltip";
import {decrypt, encrypt} from "../../../helpers/encryption";
import ChallengeList from "../../challenges/list";

const ChallengeTalbe = props => {

    const {authenticated} = useSelector(state => state.authenticationReducer)
    const {selectedWallet} = useSelector(state => state.authenticationReducer)
    const {data, gameName} = props

    const {t, i18n} = useTranslation()

    const [searchParams, setSearchParams] = useSearchParams()

    const [rates, setRates] = useState({})

    const getAmountInConversion = amount => {
        if (!selectedWallet?.code)
            return ''

        if (selectedWallet?.code === 'USDT' || selectedWallet?.code === 'USDC')
            return Big(amount || 0).toFixed(2)

        return Big(amount || 0).times(rates[selectedWallet?.code] || 0).toFixed(['TRY', 'USD', 'USDT'].includes(selectedWallet?.code) ? 2 : 5)
    }

    useEffect(() => {
        const handleFiatRates = e => {
            const data = decrypt(e)
            setRates(data)
        }
        window?.tcpSocket?.emit('fiat:rate', encrypt({
            currency: 'USD'
        }))

        window?.tcpSocket?.on('fiat:rates', handleFiatRates)
    }, [])


    if (data?.length <= 0)
        return <NoData desc={t('challenges.empty')}/>



    return (
        <div className="table-responsive">
            <table className="xtable">
                <thead>
                <tr>
                    <th>{t('challenges.minimum_bet')}</th>
                    <th>{t('challenges.multiplier')}</th>
                    <th>{t('challenges.prize')}</th>
                    <th>{t('challenges.status')}</th>
                </tr>
                </thead>
                <tbody>
                {
                    data?.map((stat, o) =>
                        <tr key={stat?.timestamp}>
                            <td>
                                <div className="xtable__text">
                                    {
                                        selectedWallet?.code &&
                                        <Tooltip className="tooltip-me"
                                                 anchorSelect={`#challenge-${stat?.id}`}>
                                                            <span className="xtable__coin gap-1">
                                                                <span>{getAmountInConversion(stat?.min_bet_usd)}</span>
                                                                <InstrumentIcon code={selectedWallet?.code}/>
                                                            </span>
                                        </Tooltip>
                                    }
                                    <span
                                        id={`challenge-${stat?.id}`}
                                        className={'d-flex align-items-center justify-content-center gap-2'}>
                                                            $ {Big(stat?.min_bet_usd || 0).toFixed(2)}
                                        <InstrumentIcon code={selectedWallet?.code}/>
                                            </span>
                                </div>
                            </td>

                            <td>
                                <div className="xtable__text text-white">x{stat?.multiplier}</div>
                            </td>

                            <td>
                                <div className="xtable__text">

                                    {
                                        selectedWallet?.code &&
                                        <Tooltip className="tooltip-me"
                                                 anchorSelect={`#prize-${stat?.id}`}>
                                                            <span className="xtable__coin gap-1">
                                                                <span>{getAmountInConversion(stat?.prize_usd)}</span>
                                                                <InstrumentIcon code={selectedWallet?.code}/>
                                                            </span>
                                        </Tooltip>
                                    }
                                    <span
                                        id={`prize-${stat?.id}`}
                                        className={'d-flex align-items-center justify-content-center gap-1'}>
                                        <InstrumentIcon code={'USDT'}/>
                                                            $ {Big(stat?.prize_usd || 0).toFixed(2)}
                                            </span>
                                </div>

                            </td>
                            <td>
                                <div
                                    className={`xtable__coin xtable__coin--${stat?.claimed_by ? 'red' : 'green'} gap-1`}>
                                    {
                                        stat?.claimed_by ? t('challenges.completed') : t('challenges.active')
                                    }
                                </div>
                            </td>
                        </tr>
                    )
                }
                </tbody>
            </table>
        </div>
    )

}

export default ChallengeTalbe
